export enum NotifyMissingDocumentFormKeys {
  DOCUMENTS_LIST = 'documentsList',
}

export type NotifyMissingDocumentFormInputs = {
  [NotifyMissingDocumentFormKeys.DOCUMENTS_LIST]: string[];
};
